import React, { useState } from "react";
import TableHead from "./TableHead";
import Row from "./Row";
import UseTableItems from "./UseTableItems";

function Table(props) {
  let dataItems = props.data;
  let property = props.sort.by;
  let reverse = props.sort.reverse;
  const tableItems = UseTableItems();
  const [idOfRowWithOptions, setIdOfRowWithOptions] = useState();

  if (reverse) dataItems = dataItems.sort((a, b) => a[property] - b[property]);

  const sort = () => {
    dataItems = dataItems.filter((item) => {
      let deleted = parseInt(item["Deleted"]);
      if (props.deletedView) deleted = !deleted;
      return deleted ? false : true;
    });

    // Filters
    if (props.searchValue.length > 1) {
      const regex = new RegExp(`${props.searchValue}`, "i");
      console.log(regex);
      dataItems = dataItems.filter((item) => {
        let hit = false;
        for (let property in item) {
          if (item[property] && item[property].match(regex)) hit = true;
        }
        return hit;
      });
    }

    // Sort order
    if (
      property === "ID" ||
      property === "ProblemOrError" ||
      property === "DocType"
    ) {
      if (reverse) {
        dataItems.sort((a, b) => parseInt(b[property]) - parseInt(a[property]));
      } else {
        dataItems.sort((a, b) => parseInt(a[property]) - parseInt(b[property]));
      }
    } else if (
      property === "DateReportedByManager" ||
      property === "DateDone"
    ) {
      dataItems.sort((a, b) => {
        let d1 = new Date(a[property]);
        let d2 = new Date(b[property]);
        if (reverse) {
          return d2 - d1;
        } else {
          return d1 - d2;
        }
      });
    } else {
      if (reverse) {
        dataItems.sort((a, b) => a[property].localeCompare(b[property]));
      } else {
        dataItems.sort((a, b) => b[property].localeCompare(a[property]));
      }
    }
    //console.log(property, dataItems) //.map(item => item[property]))
  };

  sort();
  let rows = dataItems.map((item, index) => {
    return (
      <Row
        item={item}
        user={props.user}
        userType={props.userType}
        tabItems={tableItems}
        key={index}
        id={index}
        setUpdate={props.setUpdate}
        showModal={props.showModal}
        setModalData={props.setModalData}
        setCurrentData={props.setCurrentData}
        deletedView={props.deletedView}
        setIdOpt={setIdOfRowWithOptions}
        idOpt={idOfRowWithOptions}
        modalProps={props.modalProps}
      />
    );
  });

  return (
    <div
      className={
        "tableWrap" +
        " " +
        props.view +
        (props.deletedView ? " deletedView" : "")        
      }
    >
      <div className="tableInfo" onClick={()=> {setIdOfRowWithOptions(null)}}>
        <h1>Rejestr błędów księgowych</h1>
        <div className="tableType">
          {props.tableTypeText ? "Lista" : "Usunięte"}
        </div>
        <div className="userName">
          Zalogowany jako: <span className="user">{props.user}</span> / {props.userType}
        </div>
      </div>
      <div className="mainTable">
        <TableHead
          tabItems={tableItems}
          sort={props.sort}
          setSort={props.setSort}
          setIdOpt={setIdOfRowWithOptions}
        />
        <div className="tableBody">{rows}</div>
      </div>
    </div>
  );
}

export default Table;
